module.exports = __webpack_public_path__ + "img/emojise-logo-small.3892fcb5.png";